import { render, staticRenderFns } from "./XJSONStream.vue?vue&type=template&id=50bcc006&scoped=true&"
import script from "./XJSONStream.vue?vue&type=script&lang=js&"
export * from "./XJSONStream.vue?vue&type=script&lang=js&"
import style0 from "./XJSONStream.vue?vue&type=style&index=0&id=50bcc006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bcc006",
  null
  
)

export default component.exports